import { render } from "./CadastrarGrupoApoio.vue?vue&type=template&id=f8b29002&scoped=true"
import script from "./CadastrarGrupoApoio.vue?vue&type=script&lang=js"
export * from "./CadastrarGrupoApoio.vue?vue&type=script&lang=js"

import "./CadastrarGrupoApoio.vue?vue&type=style&index=0&id=f8b29002&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b29002"]])

export default __exports__